var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"header-solid h-full",attrs:{"bordered":false,"bodyStyle":{ padding: '20px' }}},[_c('tripTool',{ref:"tripTool",attrs:{"showCustomer":"","showAddButton":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }